<div id="layout-wrapper">

    <app-topbar-prj (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()">
    </app-topbar-prj>
  
    <app-sidebar-prj [isCondensed]="isCondensed"></app-sidebar-prj>
  
    <div class="main-content">
      <div class="page-content">
        <!-- content -->
        <router-outlet></router-outlet>
      </div>
  
      <!-- footer -->
    </div>
  </div>